import axios from 'axios';

let stocksRequest = null;
let stocksRevision = 0;

const client = axios.create({ baseURL: process.env.VUE_APP_API || '', withCredentials: true, timeout: 60000 });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('user_access_token');
  if (token) config.headers.authorization = `Bearer ${token}`;
  return config;
});

export async function loadLegacyFinder(defaults = false) {
  const { data } = await client.get('/api/v1/stock-finder/default-finder', { params: defaults ? { defaults: 1 } : {} });
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Respuesta de filtros inválida');
  return data;
}

export async function saveLegacyFinder(finder, crypto) {
  const params = new URLSearchParams();
  params.append('finder', JSON.stringify(finder));
  params.append('search_mode', crypto ? 'crypto' : 'stock_market');
  await client.post('/api/v1/stock-finder/update-last-search', params);
  ++stocksRevision;
  stocksRequest = null;
}

export async function saveLegacyNamedFinder(name, finder) {
  const params = new URLSearchParams();
  params.append('name', name.trim().replace(/\s+/g, 'Q1SPACEQ1'));
  params.append('finder', JSON.stringify(finder));
  await client.post('/api/v1/stock-finder/create-finder', params);
}

export function loadLegacyFinderStocks(scope = '', compact = false) {
  const identity = JSON.stringify([localStorage.getItem('user_access_token'), scope, compact]);
  if (stocksRequest && stocksRequest.identity === identity) return stocksRequest.task;
  const revision = stocksRevision;
  const task = client.get('/api/v1/stock-finder/stocks', { params: compact ? { view: 'legacy-chart' } : {} }).then(({ data }) => {
    if (revision !== stocksRevision) { const stale = new Error('Búsqueda sustituida'); stale.code = 'STALE_QUERY'; throw stale; }
    if (!Array.isArray(data)) throw new Error('Respuesta de valores inválida');
    return data;
  }).catch(error => {
    if (revision !== stocksRevision) { error.code = 'STALE_QUERY'; throw error; }
    throw error;
  }).finally(() => { if (stocksRequest && stocksRequest.task === task) stocksRequest = null; });
  stocksRequest = { identity, task };
  return task;
}
